import { useTranslation } from '@/i18n/hook';
import { categories } from '@/mocks/categories';

const catImages = [
  'https://readdy.ai/api/search-image?query=Single%20white%20sneaker%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-shoes&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Folded%20beige%20hoodie%20sweater%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-hoodies&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Folded%20white%20cotton%20t-shirt%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-tshirts&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Dark%20denim%20jacket%20on%20hanger%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-jackets&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Folded%20casual%20chino%20pants%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-pants&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Black%20baseball%20cap%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-headwear&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Matching%20streetwear%20outfit%20set%20folded%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-sets&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Folded%20cotton%20underwear%20boxer%20briefs%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-underwear&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Sports%20football%20jersey%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-jersey&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Watch%20sunglasses%20and%20wallet%20accessories%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-accessories&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Brown%20leather%20handbag%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-bags&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Coiled%20leather%20belt%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-belts&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Glass%20perfume%20bottle%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-perfumes&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20gadgets%20and%20accessories%20product%20photography%20on%20clean%20cream%20studio%20background%20soft%20light%20minimal%20ecommerce%20style&width=600&height=600&seq=cat-other&orientation=squarish',
];

export default function CategoryGrid() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const getName = (c: typeof categories[0]) => {
    if (currentLang === 'de') return c.nameDe;
    if (currentLang === 'en') return c.nameEn;
    return c.name;
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
          {t('categories.h2')}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all flex flex-col"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={catImages[idx] || catImages[13]}
                  alt={getName(cat)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 text-center">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                  {getName(cat)}
                </span>
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-5 py-2.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap"
          >
            {t('categories.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}